/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetContractNumberQuery } from '../../models/get-contract-number-query';
import { GetContractorNumberQueryResult } from '../../models/get-contractor-number-query-result';

export interface ApiCommonDashboardGetContractNumberGet$Params {
  query?: GetContractNumberQuery;
}

export function apiCommonDashboardGetContractNumberGet(http: HttpClient, rootUrl: string, params?: ApiCommonDashboardGetContractNumberGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContractorNumberQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiCommonDashboardGetContractNumberGet.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetContractorNumberQueryResult>;
    })
  );
}

apiCommonDashboardGetContractNumberGet.PATH = '/api/Common/Dashboard/GetContractNumber';
